
type Route = {
  name: string
  path: string
  pageTitle?: string
}

export const protectedRoutes: Record<string, Route> = {
  Login: {
    name: 'ログイン',
    path: 'login',
  },
  AuthAction: {
    name: '認証アクション',
    path: '/auth-action',
  },
  PasswordRest: {
    name: 'パスワード',
    path: '/password-reset',
  },
  Top: {
    name: 'トップページ',
    path: '/',
  },
  Dashboard: {
    name: 'ダッシュボード',
    path: 'dashboard',
  },
  UploadRecord: {
    name: '実績・予定登録',
    path: 'upload-record',
    pageTitle: '実績データ登録',
  },
  StockCenter: {
    name: '倉庫別発注商品一覧',
    path: 'stock-center',
  },
  ShipExpectedCenter: {
    name: '倉庫別',
    path: 'ship-expected-center',
    pageTitle: '倉庫別出荷予測',
  },
  ShipExpectedItem: {
    name: '商品別',
    path: 'ship-expected-item',
    pageTitle: '商品別出荷予測',
  },
  UploadMaster: {
    name: 'アップロード',
    path: 'upload',
    pageTitle: 'マスタメンテ',
  },
  Faq: {
    name: '操作マニュアル',
    path: 'faq',
  },
  UserList: {
    name: 'ユーザー管理',
    path: 'user-list',
  },
  UserDetail: {
    name: 'ユーザー情報更新',
    path: 'user-detail',
  },
  CompanyList: {
    name: 'ユーザー企業管理',
    path: 'company-list',
  },
  CompanyDetail: {
    name: 'ユーザー企業情報更新',
    path: 'company-detail',
  },
  AuthSetting: {
    name: '2段階認証設定',
    path: 'auth-setting',
  },

  MasterItem:{
    name: '商品マスタ',
    path: 'mst_item',
  },
  MasterCalendar:{
    name: 'センターカレンダー',
    path: 'mst_calendar',
  },
  MasterCenter:{
    name: '自社センター管理',
    path: 'mst_center',
  },
  MasterStockCenterItem:{
    name: 'センター在庫管理',
    path: 'mst_center_stock_item',
  },
  MasterSupplier:{
    name: '仕入先管理',
    path: 'mst_supplier',
  },
  MasterCenterSupplier:{
    name: 'センター仕入先',
    path: 'mst_center_supplier',
  },
  MasterCustomer:{
    name: '得意先企業',
    path: 'mst_customer',
    pageTitle: '得意先',
  },
  MasterCustomerCenter:{
    name: '得意先センター',
    path: 'mst_customer_center',
  },
  MasterTransport:{
    name: '輸送',
    path: 'mst_transport_relation',
  },
  MasterTransportType: {
    name: '輸送種類',
    path: 'mst_transport_type'
  },
  OrderPlanTransportLot: {
    name: '発注計画　積載率最適化',
    path: 'order-plan-transport-lot',
    pageTitle: '発注計画 積載率最適化',
  },
  MasterCenterSupplierCalendar: {
    name: 'センター仕入先カレンダー',
    path: 'mst_center_supplier_calendar'
  }
}
